<template>
  <Head :title="__('index.meta.title')">
    <meta
      name="description"
      :content="__('index.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.index')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="all-vips-hero pt-16 lg:pt-12 relative">
    <img
      src="/frontend/assets/mobile-hero-swirl.svg"
      class="absolute top-0 left-0 lg:hidden"
    >
    <img
      src="/frontend/assets/desktop-hero-swirl.svg"
      class="absolute z-40 top-0 left-0 hidden lg:block"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          Bestel een video-boodschap
        </h1>

        <p class="text-gray-400 mt-2 lg:text-xl">
          {{ __('vips.text') }}
        </p>
      </div>
    </div>
  </section>

  <section class="sticky z-30 top-0 pt-[5.5rem] md:pt-20 pb-3 bg-red-100 border-b border-gray-200">
    <VipsFilter
      ref="vipsFilter"
      v-model:search="search"
      :total-vips="filteredVipsCount"
      :highest-vip-price="highestVipPrice"
      :occasions="occasions"
      :popular-categories="popularCategories"
      :categories="categories"
      :initial-search="initialSearch"
      :initial-filter="initialFilter"
      @filter:reset="resetFilter"
      @filter:recalculate="recalculateFilter"
      @filter:submit="submitFilter"
    />
  </section>

  <section class="all-vips bg-white pb-12">
    <div v-show="filteredVips.length > 0">
      <div
        v-for="(vipsGroup, i) in groupedVips"
        :key="`vip-group-${i}`"
      >
        <div class="container">
          <div class="w-full md:order-3">
            <div class="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-8 my-4">
              <Vip
                v-for="vip in vipsGroup"
                :key="`vip-${vip.username}-${vip.id}`"
                :vip="vip"
                :always-mobile="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="filteredVips.length === 0">
      <section class="all-vips-no-results bg-white pb-20 overflow-hidden">
        <div class="container">
          <div class="mt-4 text-center">
            <span class="block text-center text-2xl lg:text-5xl">
              <i18n-t
                keypath="vips.nothing-found"
                scope="global"
              >
                <template #count>
                  <strong>0</strong>
                </template>
              </i18n-t>
            </span>
          </div>
        </div>
      </section>
    </div>
  </section>

  <CallToAction :show-scribble="false" />
</template>

<script>
import VipsFilterMixin from '../../Mixins/VipsFilter';
import Vip from '../../Components/Vip.vue';
import CallToAction from '../../Components/CallToAction.vue';
import VipsFilter from '../../Components/VipsFilter.vue';

export default {
  components: {
    VipsFilter,
    Vip,
    CallToAction,
  },

  mixins: [VipsFilterMixin],

  methods: {
    filterRoute() {
      return this.localeRoute('frontend.index');
    },
  },
};
</script>
